import React from 'react';
import P, { string } from 'prop-types';
import './styles.css';

export const Button = ({
  className = '',
  text = '',
  textAlign = 'center',
  text2 = '',
  text2Align = 'right',
  onClick,
  disabled,
  icon,
  iconAlign = 'center',
  type = 'button',
  id = '',
  classDisabled = 'btnDisabled',
}) => {
  let classIconAlign = '';
  if (iconAlign == 'right') classIconAlign = 'btnIconAlignRight';
  if (iconAlign == 'left') classIconAlign = 'btnIconAlignLeft';
  return (
    <>
      <button
        id={id}
        type={type}
        disabled={disabled}
        // className={`${disabled ? className + ' btnDisabled' : className}`}
        className={`${disabled ? className + ' ' + classDisabled + ' ' : className}`}
        onClick={onClick}
      >
        <div style={{ width: '100%' }}>
          {icon && (
            <i
              className={`material-icons  ${classIconAlign}`}
              style={{
                fontWeight: icon === 'check' ? 600 : 500,
                fontSize: icon === 'add' || icon === 'remove' ? 28 : 24,
              }}
            >
              {icon}
            </i>
          )}
          {text !== '' && textAlign === 'center' && <span style={{ textAlign: textAlign }}>{text}</span>}
          {text !== '' && textAlign !== 'center' && <span style={{ float: textAlign }}>{text}</span>}

          {text2 !== '' && (
            <span className="text2FontSize" style={{ float: text2Align }}>
              {text2}
            </span>
          )}
        </div>
      </button>
    </>
  );
};

Button.propTypes = {
  className: P.string,
  text: P.string,
  textAlign: P.string,
  text2: P.string,
  text2Align: P.string,
  onClick: P.func,
  disabled: P.bool,
  icon: P.string,
  iconAlign: P.string,
  type: P.string,
  id: string,
  classDisabled: P.string,
};
